import * as requestFromServer from "./internationalCallsCrud";
import {internationalCallsSlice, callTypes} from "./internationalCallsSlice";

const {actions} = internationalCallsSlice;

export const fetchInternationalCalls = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findInternationalCalls(queryParams)
    .then(response => {
      const { totalCount, list, data } = response.data;
      dispatch(actions.internationalCallsFetched({ totalCount, list,data }));
    })
    .catch(error => {
      error.clientMessage = "Can't find internationalCalls";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
